import React, { useEffect, useRef, useState } from "react";
import {
  service,
  searchInput$,
} from "@uidaholib/shared/machines/search/search.machine";
import { useService } from "@xstate/react";
import { MdSearch } from "react-icons/md";
import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Spinner,
  Box,
  PopoverTrigger,
  PopoverContent,
  Popover,
  List,
  ListItem,
  Icon,
  Tooltip,
} from "@chakra-ui/react";
import { useDebounce } from "react-use";
import { Analytic } from "@uidaholib/shared/api/analytics";
import { configStore } from "@uidaholib/shared/models/config/config";
import { observer } from "mobx-react-lite";

const Search = observer(() => {
  const [state, send] = useService(service);
  const [isOpen, setIsOpen] = useState(false);
  const [text, setText] = useState("");
  const inputRef = useRef();

  const config = configStore.getConfig();

  useDebounce(
    () => {
      if (text.length > 0) {
        searchInput$.next(text);
        Analytic.sendEvent({
          label: text,
          category: config.analytics.search.category,
          action: config.analytics.search.terms,
        });
      }
    },
    500,
    [text]
  );

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const onSearch = (e) => {
    setText(e.target.value);
  };

  const onSuggestionClick = (term) => {
    send({ type: "SEARCH", payload: { term } });
    Analytic.sendEvent({
      label: term,
      category: config.analytics.search.category,
      action: config.analytics.search.suggestion,
    });
  };

  const isMatch = [{ suggestions: "retrieved" }].some(state.matches);

  return (
    <Popover
      initialFocusRef={inputRef}
      gutter={2}
      placement="bottom-start"
      isOpen={isMatch}
      onClose={close}
      onOpen={open}
      closeOnBlur={true}
    >
      <PopoverTrigger>
        <Box p={0} m={0}>
          <InputGroup>
            <InputLeftElement children={<Icon as={MdSearch} boxSize={6} />} />
            <Input
              ref={inputRef}
              onChange={onSearch}
              value={text}
              type="text"
              rounded="lg"
              placeholder="Address, place, or location"
            />
            {state.matches({ suggestions: "retrieving" }) && (
              <InputRightElement
                display="block"
                children={<Spinner mt={1} />}
              />
            )}
          </InputGroup>
        </Box>
      </PopoverTrigger>
      <PopoverContent boxShadow="lg" zIndex={2} p={0}>
        <List p={0}>
          {state.context.suggestions.map((suggestion) => (
            <ListItem
              key={suggestion.key}
              px={3}
              py={2}
              _odd={{ bg: "gray.100" }}
              _hover={{ color: "blue.400" }}
              cursor="pointer"
              onClick={() => onSuggestionClick(suggestion.text)}
            >
              {suggestion.text}
            </ListItem>
          ))}
        </List>
      </PopoverContent>
    </Popover>
  );
});

export default Search;
